import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import moment from 'moment';
import { AppComponent } from 'src/app/app.component';
import { Api } from 'src/smoothr-web-app-core/api/api';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import Order from 'src/smoothr-web-app-core/models/Order';

@Component({
	selector: 'app-my-orders-modal',
	templateUrl: './my-orders-modal.component.html',
	styleUrls: ['./my-orders-modal.component.scss'],
})
export class MyOrdersModalComponent implements OnInit {
	public customer: Customer;
	public orders: Order[] = [];

	constructor(private modalCtrl: ModalController) {}

	ngOnInit() {}

	get doneOrders(): Order[] {
		return this.orders.filter(value => value.isPayed);
	}

	static async show(modalCtrl: ModalController, orders: Order[]): Promise<void> {
		const modal = await modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'sign-modal' : 'menu-modal',
			component: MyOrdersModalComponent,
			componentProps: {
				orders: orders.reverse(),
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
